import { Component, input, InputSignal } from '@angular/core';
import { ISidebarMenu } from '../../../../entities/sidebar/menu.entity';
import { SidebarItemComponent } from '../item/sidebar-item.component';
import { NgClass } from '@angular/common';

@Component({
  selector: 'aw-sidebar-menu',
  templateUrl: './sidebar-menu.component.html',
  styles: ``,
  imports: [SidebarItemComponent, NgClass],
})
export class SidebarMenuComponent {
  menu: InputSignal<ISidebarMenu | undefined> = input.required<
    ISidebarMenu | undefined
  >();
  sideBarExpanded: InputSignal<boolean> = input<boolean>(true);

  toggleExpansion(): void {
    this.menu()!.expanded = !this.menu()!.expanded;
  }
}
